import * as React from 'react';

function SvgSpringPlus9(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.534 22.611v2.28L3.327 27.933l20.103 3.558-20.103 3.556 20.103 3.557-20.103 3.558 20.105 3.557-20.105 3.556 20.103 3.558-20.103 3.557 20.103 3.556-20.103 3.558 20.101 3.557-2.894.512V72.384h5v-2.277l17.205-3.045-20.102-3.557 20.102-3.558-20.104-3.556 20.104-3.557-20.102-3.558L42.74 45.72l-20.102-3.557 20.102-3.558-20.104-3.556 20.104-3.557-20.102-3.557 2.897-.513V22.612h-5z"
        fill={props.springcolor}
      />
      <path
        d="M23.033 118.704v6.972l-10.051 6.545 20.103 13.091-20.103 13.09 20.103 13.091-20.103 13.091 20.103 13.09-20.103 13.091 20.103 13.091-20.103 13.091 20.103 13.09-20.103 13.091 20.103 13.091-10.052 6.545v6.972"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M34.566 0h-23v23h23V0zM34.566 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringPlus9;
